export const storeTag = {
  editor: {
    nameLabel: 'Текст тега',
    namePlaceholder: 'Например, RATTEN',
    nameHint: 'Буквы, цифры, пробел и символы _ . - !',
    counter: (length: number, max: number): string => `${length} / ${max}`,
    nameErrors: {
      length: 'Длина текста — от 2 до 20 символов.',
      chars: 'Можно только буквы, цифры, пробел и символы _ . - !',
      start: 'Тег должен начинаться с буквы или цифры.',
      spaces: 'Уберите двойные пробелы.'
    },
    presetsTitle: 'Готовые стили',
    presetAria: (name: string): string => `Стиль «${name}»`,
    presets: {
      gold: 'Золото',
      ember: 'Янтарь',
      rose: 'Роза',
      mint: 'Мята',
      sky: 'Небо',
      violet: 'Фиалка',
      sunset: 'Закат',
      aurora: 'Аврора',
      toxic: 'Токсик',
      ocean: 'Океан',
      flame: 'Пламя',
      candy: 'Конфета'
    },
    customTitle: 'Свой цвет',
    customHint: 'Один цвет — сплошной, от двух до шести — градиент.',
    colorAria: (index: number): string => `Цвет ${index}`,
    hexAria: 'Код цвета',
    paletteAria: 'Палитра',
    colorDone: 'Готово',
    addColor: '+ цвет',
    removeColorAria: (index: number): string => `Удалить цвет ${index}`,
    angleTitle: 'Направление градиента',
    angleAria: (degrees: number): string => `Направление ${degrees}°`,
    iconTitle: 'Иконка',
    iconOptional: 'необязательно',
    iconUpload: 'Загрузить иконку',
    iconReplace: 'Заменить',
    iconRemove: 'Убрать иконку',
    iconProcessing: 'Обрабатываем…',
    iconHint: 'PNG, JPEG или WebP до 5 МБ. Мы вырежем квадрат по центру и уменьшим до 64×64.',
    iconPreviewAlt: 'Иконка тега',
    iconErrors: {
      type: 'Подходят только PNG, JPEG и WebP.',
      size: 'Файл больше 5 МБ. Выберите изображение поменьше.',
      decode: 'Не удалось прочитать изображение. Попробуйте другой файл.'
    },
    previewPlaceholderName: 'Тег'
  },
  page: {
    kicker: 'Свой тег',
    title: 'Создайте свой тег',
    subtitle: 'Тег показывается рядом с ником в матчах. Покупка навсегда, перед выдачей тег проверит модератор.',
    stepsAria: 'Шаги оформления',
    steps: {
      style: 'Оформление',
      confirm: 'Подтверждение'
    },
    loginTitle: 'Войдите, чтобы создать тег',
    loginDescription: 'Тег привязывается к вашему игровому аккаунту, поэтому нужен вход через Steam. После входа вы вернётесь на эту страницу.',
    loading: 'Загружаем товар…',
    unavailableTitle: 'Покупка тега пока недоступна',
    unavailableText: 'Мы ещё не открыли продажу тегов. Загляните позже.',
    loadFailed: 'Не удалось загрузить товар',
    backToStore: 'Вернуться в магазин',
    previewTitle: 'Так тег выглядит в игре',
    previewHint: 'Карточка игрока в матче. Длинный текст в игре автоматически уменьшается.',
    contactLabel: 'Как с вами связаться, если с тегом что-то не так',
    contactPlaceholder: '@nickname в Discord, Telegram или ссылка на Steam',
    contactHint: 'Модератор напишет вам, если тег придётся поправить. Укажите то, что вы читаете: Discord, Telegram или Steam.',
    contactError: 'Контакт должен быть от 2 до 500 символов.',
    next: 'Далее',
    back: 'Назад'
  },
  confirm: {
    title: 'Проверьте заказ',
    previewTitle: 'Ваш тег',
    summaryName: 'Текст тега',
    summaryContact: 'Контакт для связи',
    summaryTerm: 'Срок',
    summaryPrice: 'Цена',
    summaryForever: 'Навсегда',
    payTitle: 'Оплата',
    submit: 'Оплатить',
    editStyle: 'Изменить оформление',
    mustFixStyle: 'Вернитесь на шаг «Оформление» и исправьте текст, цвета или иконку.'
  },
  card: {
    cta: 'Создать свой тег',
    ctaAria: (name: string): string => `Создать свой тег: ${name}`
  },
  status: {
    'awaiting-payment': 'Ожидает оплаты',
    'pending-moderation': 'На модерации',
    approved: 'Одобрен',
    rejected: 'Отклонён'
  },
  order: {
    title: 'Ваш тег',
    contactLabel: 'Контакт для связи',
    moderatorComment: 'Комментарий модератора',
    awaitingPayment: 'Тег появится на модерации после оплаты заказа.',
    pendingModerationTitle: 'Оплата получена, тег на модерации',
    pendingModerationText: 'Модератор проверит тег и при необходимости напишет вам по указанному контакту. После одобрения тег появится у вас в игре.',
    approvedTitle: 'Тег одобрен: он уже у вас',
    approvedText: 'Тег привязан к вашему игровому аккаунту и будет виден в игре.',
    rejectedTitle: 'Тег отклонён',
    rejectedText: 'Деньги за заказ будут возвращены вручную. Если есть вопросы, напишите в поддержку и укажите номер заказа.',
    rowTag: (name: string): string => `Тег «${name}»`
  },
  admin: {
    status: {
      all: 'Все',
      'pending-moderation': 'На модерации',
      approved: 'Одобрены',
      rejected: 'Отклонены'
    },
    filterStatus: 'Статус',
    loadFailed: 'Не удалось загрузить заявки на теги',
    empty: 'Заявок на теги нет',
    tableAria: 'Заявки на теги',
    player: 'Игрок',
    playerUid: (uid: string): string => `UID ${uid}`,
    order: 'Заказ',
    contact: 'Контакт',
    created: 'Создана',
    paid: 'Оплачена',
    tagCode: 'Код тега',
    moderated: (name: string, date: string): string => `Проверил: ${name}, ${date}`,
    moderatedNoName: (date: string): string => `Проверено: ${date}`,
    comment: 'Комментарий модератора',
    edit: 'Изменить',
    approve: 'Одобрить',
    reject: 'Отклонить',
    editAria: (name: string): string => `Изменить тег ${name}`,
    approveAria: (name: string): string => `Одобрить тег ${name}`,
    rejectAria: (name: string): string => `Отклонить тег ${name}`,
    editDialog: {
      title: 'Правка тега',
      save: 'Сохранить',
      saving: 'Сохраняем…',
      invalid: 'Проверьте текст и цвета тега.'
    },
    approveDialog: {
      title: 'Одобрить тег?',
      description: 'Тег будет назначен игроку и заменит его текущий тег.',
      confirm: 'Одобрить'
    },
    rejectDialog: {
      title: 'Отклонить тег',
      description: 'Тег будет удалён, игрок увидит причину на странице заказа. Деньги нужно вернуть вручную.',
      commentLabel: 'Причина отказа',
      commentPlaceholder: 'Например, текст нарушает правила сообщества',
      commentRequired: 'Укажите причину отказа.',
      commentTooLong: 'Причина слишком длинная (не более 500 символов).',
      confirm: 'Отклонить',
      back: 'Назад'
    },
    toasts: {
      updated: 'Тег обновлён',
      approved: 'Тег одобрен и назначен игроку',
      rejected: 'Заявка отклонена'
    }
  }
};
